export const isOAuthAuthorizationPath = (
  pathname: string,
  search = '',
): boolean => {
  pathname = pathname.replace(/\.data$/, '');
  if (
    pathname === '/oauth/authorize' ||
    pathname.startsWith('/oauth/authorize/')
  ) {
    return true;
  }
  if (!pathname.startsWith('/auth/')) return false;
  const from = new URLSearchParams(search).get('from');
  return !!from && isOAuthAuthorizationPath(from.split(/[?#]/)[0]);
};
